"use strict";
(function(){
    
    var AbstractView = function(){}
    AbstractView.prototype = {
        playIn:function(){},
        playOut:function(){}
    };
    module.exports = AbstractView;
    
}());


/** WEBPACK FOOTER **
 ** ./holiday-map/abstractview.js
 **/